import { c, classy } from '@onfido/castor';
import React, { useEffect } from 'react';
import { MaybeIcon } from '../../internal';
import { textContent } from '../../utils';
import { useOptionList } from './useOptionList';
export function Option({ children, className, disabled, hidden, keywords, value: optionValue, onClick, onKeyUp, ...restProps }) {
    const { icon, initialize, name, search, select, value } = useOptionList();
    useEffect(() => initialize(children, optionValue), []);
    if (hidden)
        return null;
    if (!matches(search, children, optionValue, keywords))
        return null;
    const selectOption = () => disabled || select(children, optionValue);
    const selected = value == optionValue;
    return (React.createElement("label", { ...restProps, className: classy(c('option'), className), onClick: (event) => {
            // moving through options with arrow keys (onChange) will trigger
            // onClick events here, but we don't want to select then, so we filter
            // only events that have detail, which are triggered by mouse clicks
            if (event.detail)
                selectOption();
            onClick === null || onClick === void 0 ? void 0 : onClick(event);
        }, onKeyUp: (event) => {
            if (selectOptionKeys.has(event.key))
                selectOption();
            onKeyUp === null || onKeyUp === void 0 ? void 0 : onKeyUp(event);
        } },
        React.createElement("input", { className: classy(c('option-input')), checked: selected, disabled: disabled, name: name, readOnly: true, type: "radio" }),
        React.createElement("span", { role: "option", className: classy(c('option-content')) }, children),
        selected && !disabled && React.createElement(MaybeIcon, { icon: icon, name: "check" })));
}
const matches = (search, children, value, keywords) => {
    if (keywords === true)
        return true;
    const label = textContent(children);
    const term = search === null || search === void 0 ? void 0 : search.toLowerCase().trim();
    const values = [label, value, keywords].flat().map(String).filter(Boolean);
    return !term || values.some((v) => v === null || v === void 0 ? void 0 : v.toLowerCase().includes(term));
};
const selectOptionKeys = new Set([' ', 'Enter']);
//# sourceMappingURL=option.js.map